import React, { useState, useEffect } from 'react';

interface RemoteFilterModalProps {
  show: boolean;
  selectedRemoteTypes: string[];
  onClose: () => void;
  onApply: (remoteTypes: string[]) => void;
}

const remoteOptions = [
  { value: 'remote', label: 'リモートOK' },
  { value: 'full_remote', label: 'フルリモート' },
  { value: 'onsite', label: '常駐' }
];

const RemoteFilterModal: React.FC<RemoteFilterModalProps> = ({
  show,
  selectedRemoteTypes,
  onClose,
  onApply
}) => {
  const [tempSelected, setTempSelected] = useState<string[]>(selectedRemoteTypes);

  useEffect(() => {
    if (show) {
      setTempSelected(selectedRemoteTypes);
    }
  }, [show, selectedRemoteTypes]);

  const handleToggle = (remoteType: string) => {
    const newSelected = tempSelected.includes(remoteType)
      ? tempSelected.filter(type => type !== remoteType)
      : [...tempSelected, remoteType];
    
    setTempSelected(newSelected);
  };

  const handleSelectAll = () => {
    setTempSelected(remoteOptions.map(option => option.value));
  };

  const handleClearAll = () => {
    setTempSelected([]);
  };

  const handleApply = () => {
    onApply(tempSelected);
    onClose();
  };

  if (!show) {
    return null;
  }

  return (
    <>
      {/* Backdrop */}
      <div 
        className="modal-backdrop fade show" 
        style={{ 
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 10060 
        }}
        onClick={onClose}
      />
      
      {/* Modal */}
      <div 
        className="modal fade show d-block" 
        style={{ 
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 10061,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        tabIndex={-1}
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            onClose();
          }
        }}
      >
        <div className="modal-dialog modal-dialog-scrollable modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">勤務形態を選択</h5>
              <button 
                type="button" 
                className="btn-close" 
                onClick={onClose}
                aria-label="閉じる"
              />
            </div>
            
            <div className="modal-body">
              {/* 選択/解除ボタン */}
              <div className="d-flex gap-2 mb-3">
                <button 
                  className="btn btn-sm btn-outline-primary"
                  onClick={handleSelectAll}
                >
                  一括選択
                </button>
                <button 
                  className="btn btn-sm btn-outline-danger"
                  onClick={handleClearAll}
                >
                  一括解除
                </button>
                <div className="ms-auto text-muted small">
                  {tempSelected.length}件選択中
                </div>
              </div>

              {/* 勤務形態リスト */}
              <div className="row g-2">
                {remoteOptions.map(option => (
                  <div key={option.value} className="col-6 col-md-4 col-lg-3">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`remote-${option.value}`}
                        checked={tempSelected.includes(option.value)}
                        onChange={() => handleToggle(option.value)}
                      />
                      <label className="form-check-label" htmlFor={`remote-${option.value}`} style={{ cursor: 'pointer' }}>
                        {option.label}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="modal-footer">
              <button 
                type="button" 
                className="btn btn-secondary"
                onClick={onClose}
              >
                キャンセル
              </button>
              <button 
                type="button" 
                className="btn btn-primary"
                onClick={handleApply}
              >
                この条件で検索
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RemoteFilterModal;
